import { combineReducers } from 'redux';
import { userReducer } from './UserReducers';
import { accountReducer } from './AccountReducers';

export default combineReducers({
    userReducer,
    accountReducer
});